import { CLOUDINARY_PREFIX, DEFAULT_VARIATION_BACKGROUND, MOCK_UP_LAYERS } from '../constants';

const { IMAGE_LAYER, VARIATION_LAYER, GRADIENT_LAYER, BACKGROUND_LAYER } = MOCK_UP_LAYERS;

const WEBSITE_GRAPHICS = `${CLOUDINARY_PREFIX}99842b5661512ca923f22b92df7362d4-1577106628880/Website%20graphics.png`;
const LAPTOP_SHADOW = `${CLOUDINARY_PREFIX}a273a68a37169166b80b691dbf19e9bf-1576139997124/laptop%20contact%20shadow.png`;
const LAPTOP_SHADOW_2 = `${CLOUDINARY_PREFIX}a273a68a37169166b80b691dbf19e9bf-1576139997122/laptop%20contact%20shadow%202.png`;
const LAPTOP_BEAUTY = `${CLOUDINARY_PREFIX}dbdda84977cd5fb6a97ce1177a760f14-1577106773202/LAPTOP%20BEAUTY.png`;
const LAPTOP_BEAUTY_COMPLIMENTARY = `${CLOUDINARY_PREFIX}a273a68a37169166b80b691dbf19e9bf-1576139997113/laptop%20beauty%20complimentary.png`;
const LAPTOP_REFLECTION = `${CLOUDINARY_PREFIX}a273a68a37169166b80b691dbf19e9bf-1576139997141/laptop%20reflections.png`;
const LAPTOP_DETAILS = `${CLOUDINARY_PREFIX}a273a68a37169166b80b691dbf19e9bf-1576139997117/laptop%20details.png`;

const LARGE_SCALE = 0.17;
const MOBILE_SCALE = 0.25;

const SQUARE_CROP_STYLE = {
    transformOrigin: 'center',
    transform: 'translate(-1%, 37%) scale(1.4)',
};

export const wideMockUp = {
    layers: [
        {
            type: GRADIENT_LAYER,
            opacity: 0.54,
            background: DEFAULT_VARIATION_BACKGROUND,
        },
        {
            type: IMAGE_LAYER,
            opacity: 0.08,
            mixBlendMode: 'multiply',
            src: LAPTOP_SHADOW_2,
        },
        {
            type: IMAGE_LAYER,
            opacity: 0.04,
            mixBlendMode: 'multiply',
            src: LAPTOP_SHADOW,
        },
        {
            type: IMAGE_LAYER,
            src: LAPTOP_BEAUTY,
        },
        {
            type: IMAGE_LAYER,
            opacity: 0.28,
            mixBlendMode: 'darken',
            src: LAPTOP_BEAUTY_COMPLIMENTARY,
        },
        {
            type: IMAGE_LAYER,
            src: WEBSITE_GRAPHICS,
        },
        {
            type: BACKGROUND_LAYER,
            className: 'rectangle',
        },
        {
            type: VARIATION_LAYER,
            transform: `translate(-65.1%, -52.4%) rotate(-23deg) skew(-1deg, -2deg) scale(${LARGE_SCALE})`,
        },
        {
            type: IMAGE_LAYER,
            opacity: 0.3,
            mixBlendMode: 'soft-light',
            src: LAPTOP_REFLECTION,
        },
        {
            type: IMAGE_LAYER,
            opacity: 0.25,
            mixBlendMode: 'color-burn',
            src: LAPTOP_DETAILS,
        },
    ],
    aspectRatio: '56.25%',
};

export const squareMockUp = {
    layers: [
        {
            type: GRADIENT_LAYER,
            opacity: 0.54,
            background: DEFAULT_VARIATION_BACKGROUND,
            transformOrigin: 'center',
            transform: 'scale(1.2)',
        },
        {
            type: IMAGE_LAYER,
            opacity: 0.08,
            mixBlendMode: 'multiply',
            src: LAPTOP_SHADOW_2,
            ...SQUARE_CROP_STYLE,
        },
        {
            type: IMAGE_LAYER,
            opacity: 0.04,
            mixBlendMode: 'multiply',
            src: LAPTOP_SHADOW,
            ...SQUARE_CROP_STYLE,
        },
        {
            type: IMAGE_LAYER,
            src: LAPTOP_BEAUTY,
            ...SQUARE_CROP_STYLE,
        },
        {
            type: IMAGE_LAYER,
            opacity: 0.28,
            mixBlendMode: 'darken',
            src: LAPTOP_BEAUTY_COMPLIMENTARY,
            ...SQUARE_CROP_STYLE,
        },
        {
            type: IMAGE_LAYER,
            src: WEBSITE_GRAPHICS,
            ...SQUARE_CROP_STYLE,
        },
        {
            type: BACKGROUND_LAYER,
            className: 'rectangle-mobile',
        },
        {
            type: VARIATION_LAYER,
            transform: `translate(-72%, -54%) rotate(-23deg) skew(-1deg, -2deg) scale(${MOBILE_SCALE})`,
        },
        {
            type: IMAGE_LAYER,
            opacity: 0.3,
            mixBlendMode: 'soft-light',
            src: LAPTOP_REFLECTION,
            ...SQUARE_CROP_STYLE,
        },
        {
            type: IMAGE_LAYER,
            opacity: 0.25,
            mixBlendMode: 'color-burn',
            src: LAPTOP_DETAILS,
            ...SQUARE_CROP_STYLE,
        },
    ],
    aspectRatio: '100%',
};
